module.exports = __webpack_public_path__ + "img/fig25.21828dc2.jpg";